var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgActivedMypageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 0C13.05 0 9 5.04 9 11.25C9 17.46 13.05 22.5 18 22.5C22.95 22.5 27 17.46 27 11.25C27 5.04 22.95 0 18 0ZM8.595 22.5C3.825 22.725 0 26.64 0 31.5V36H36V31.5C36 26.64 32.22 22.725 27.405 22.5C24.975 25.245 21.645 27 18 27C14.355 27 11.025 25.245 8.595 22.5Z",
    fill: "#D94E28"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivedMypageIcon);
export default __webpack_public_path__ + "static/media/activedMypageIcon.01fc531ca0a584aebfda96d28ecab097.svg";
export { ForwardRef as ReactComponent };